export default __webpack_public_path__ + "static/media/Frame766.303c4cdf.png";